export enum PaymentType {
    ON_SPOT = 'ON_SPOT',
    STRIPE = 'STRIPE',
}
